import { Trans } from "react-i18next";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { getStepHash } from "./OnboardingRedirect";
import { ONBOARDING } from "root/RootRouter.config";
import { StepScreenId } from "./onboardingTypes";
import DownloadButton from "root/auth/DownloadButton";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  width: 100%;
`;
const Inner = styled.div`
  padding: 25px;
  background: white;
  border-radius: 50px;
  width: 100%;
`;
const Instruction = styled.div`
  margin: 1em 1em 1.5em;
  font-weight: bold;
`;
const BottomLinks = styled.div`
  color: ${({ theme }) => theme.duo.color.textGrey};
  font-size: 13px;
  span {
    cursor: pointer;
    padding: 0 2px;
  }
`;

const FollowEmailedInstructions = ({ onRequestSubmit }) => {
  const navigate = useNavigate();

  return (
    <>
      <Wrap>
        <Inner>
          <Instruction>
            <Trans>Download the DuoCards app and continue there.</Trans>
          </Instruction>
          <DownloadButton>
            <Trans>Download App</Trans>
          </DownloadButton>
        </Inner>
      </Wrap>
      <BottomLinks>
        <span onClick={() => navigate(ONBOARDING.url() + getStepHash(StepScreenId.SET_EMAIL))}>
          <Trans>I did not receive the email</Trans>
        </span>
        &nbsp; • &nbsp;
        <span onClick={onRequestSubmit}>
          <Trans>Continue in browser</Trans>
        </span>
      </BottomLinks>
    </>
  );
};

export default FollowEmailedInstructions;
